import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EngineStatisticsService, ResultDataStatisticsDto, Partner} from '@tj/tj-dmp-lib-api'; 
import {StatisticsTableElement} from './statistics-table-element.model';

@Component({
    selector: 'dmp-statistics-tab',
    templateUrl: './statistics-tab.component.html',
    styleUrls: ['./statistics-tab.component.scss'],
    standalone: false
})
export class StatisticsTabComponent implements OnChanges {
    @Input() codeTenant: string;
    @Input() codeStatistics: string;
    @Input() partners: Array<Partner> = [];
    public data: ResultDataStatisticsDto;
    public statisticsTable : StatisticsTableElement[] = [];
    public isDynamic  = false;
  constructor(private readonly translate: TranslateService,
              private readonly engineStatisticsService: EngineStatisticsService) { }


    ngOnChanges(changes: SimpleChanges) : void {
      if (!this.codeTenant || !this.codeStatistics) {
        return;
      }
      this.engineStatisticsService.getDataUsingPOST(this.codeTenant, this.codeStatistics, null, this.partners.map(p => p.code)).subscribe({
        next: data => {
          this.data = data;
          this.initTable();
        },
        error: error => console.error('Statistics table load failed', error)
      });
      this.isDynamic = false;
      if (this.codeStatistics == "DesabonnementDeLaNewsletter") {
        this.isDynamic = true;
      }
    }

    public initTable() {
      this.statisticsTable = [];
      for (const serie of this.data.series) {
        this.statisticsTable.push(new StatisticsTableElement(
          (this.isDynamic) ? serie.label : serie.code,
          this.round(serie.data[0]["sqlDayMinus1"]), 
          this.round(serie.data[0]["sqlDayMinus7"]),
          this.round(serie.data[0]["sqlMonthMinus1"]),
          this.round(serie.data[0]["sqlYearMinus1"]),
          (this.codeStatistics!='PanierMoyen') ? this.round(serie.data[0]["sqlAverage7D"]) : null,
          (this.codeStatistics!='PanierMoyen') ? this.round(serie.data[0]["sqlAverage30D"]) : null));
      }
    }

    public round(value: number) : number {
      return Math.round((value + Number.EPSILON) * 100) / 100
    }


}
